export type SessionStatus = 'loading' | 'authenticated' | 'unauthenticated'

export type SessionGuardInput = {
  status: SessionStatus
  isGuestRoute: boolean
  isPublicUrl: boolean
  hasInitIndicator: boolean
  redirectInFlight: boolean
}

export type SessionGuardResult = {
  action:
    | 'guest-route'
    | 'wait-for-status'
    | 'authenticated'
    | 'wait-for-in-flight-sign-in'
    | 'redirect-to-session'
    | 'start-sign-in'
    | 'noop'
  setPublicUrl?: boolean
  clearInitIndicator?: boolean
  setInitIndicator?: boolean
  setRedirectInFlight?: boolean
}

export const evaluateSessionGuard = ({
  status,
  isGuestRoute,
  isPublicUrl,
  hasInitIndicator,
  redirectInFlight,
}: SessionGuardInput): SessionGuardResult => {
  if (isGuestRoute) {
    return {
      action: 'guest-route',
      setPublicUrl: true,
      clearInitIndicator: true,
      setRedirectInFlight: false,
    }
  }

  if (status === 'loading') {
    return { action: 'wait-for-status' }
  }

  if (status === 'authenticated') {
    return {
      action: 'authenticated',
      clearInitIndicator: true,
      setRedirectInFlight: false,
    }
  }

  if (status === 'unauthenticated' && !isPublicUrl) {
    if (redirectInFlight) {
      return {
        action: 'wait-for-in-flight-sign-in',
        setPublicUrl: false,
      }
    }

    if (hasInitIndicator) {
      return {
        action: 'redirect-to-session',
        setPublicUrl: false,
      }
    }

    return {
      action: 'start-sign-in',
      setPublicUrl: false,
      setInitIndicator: true,
      setRedirectInFlight: true,
    }
  }

  return { action: 'noop' }
}
